/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { VideoEditorDeleteCompositionsByIdMutationResponse, VideoEditorDeleteCompositionsByIdPathParams, VideoEditorDeleteCompositionsById401, VideoEditorDeleteCompositionsById403 } from "../models/VideoEditorDeleteCompositionsById";

export function getVideoEditorDeleteCompositionsByIdUrl(id: VideoEditorDeleteCompositionsByIdPathParams["id"]) {
  const res = { method: 'DELETE', url: `/video-editor/v1/compositions/${id}` as const }
  return res
}

/**
 * @summary Delete a single Composition
 * {@link /video-editor/v1/compositions/:id}
 */
export async function videoEditorDeleteCompositionsById(id: VideoEditorDeleteCompositionsByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<VideoEditorDeleteCompositionsByIdMutationResponse, ResponseErrorConfig<VideoEditorDeleteCompositionsById401 | VideoEditorDeleteCompositionsById403>, unknown>({ method : "DELETE", url : getVideoEditorDeleteCompositionsByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}